module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark-d2d875ea75415e0d7afbfe1bceb5b1fd.png";